var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAviationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2489,
    y: 320,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2489 -320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2489,
    y: 320,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2743,
    y: 574,
    width: 1571,
    height: 1571,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2898 1359.5C2898 1011.28 3180.28 729 3528.5 729 3876.72 729 4159 1011.28 4159 1359.5 4159 1707.72 3876.72 1990 3528.5 1990 3180.28 1990 2898 1707.72 2898 1359.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3001 1359.5C3001 1070.93 3237.39 837 3529 837 3820.61 837 4057 1070.93 4057 1359.5 4057 1648.07 3820.61 1882 3529 1882 3237.39 1882 3001 1648.07 3001 1359.5Z",
    fill: "#222222",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3108.5 1361.5C3108.5 1130.09 3296.09 942.5 3527.5 942.5 3758.91 942.5 3946.5 1130.09 3946.5 1361.5 3946.5 1592.91 3758.91 1780.5 3527.5 1780.5 3296.09 1780.5 3108.5 1592.91 3108.5 1361.5Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FB4747",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviationLight);
export default __webpack_public_path__ + "static/media/AviationLight.fa4320dcedaa5ffe6ebdcd4a89ae37cf.svg";
export { ForwardRef as ReactComponent };